// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"s2-z","colorTextValue":"t2-z","swatches":"u2-z","collapseLink":"v2-z","isCollapsed":"w2-z","dropdown":"x2-z","disabled":"y2-z"};